module.exports = __webpack_public_path__ + "img/中国农业银行.af6ac168.png";